<template>
  <HeaderApp />
  <div class="mt-14"></div>

  <div
    id="printDev"
    :class="
      'mx-2 mt-14 mb-5 h-full bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 no-print ' +
      (isHide == true
        ? '  '
        : $store.getters['isRtl']
        ? $store.state.navbar.isSidebarCollapsed
          ? ' md:mr-20 '
          : ' md:mr-60 '
        : $store.state.navbar.isSidebarCollapsed
        ? ' md:ml-20  '
        : ' md:ml-60  ')
    "
  >
    <InvoiceHeader invoice_type="debt_list" v-if="isHide == true" />
    <!-- Header Section -->
    <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
      <h1 class="text-xl font-semibold text-gray-900 dark:text-white">
        {{ $t("debt_list") }}
      </h1>
    </div>

    <!-- Report Cards Section -->
    <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
      <div
        class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-x-4 gap-y-2"
      >
        <ReportComponenet1Number
          :labelTxt="formatNumber(total['total_amount_dinar'])"
          :labelTitle="$t('total_debt_dinar')"
          :classColor="
            total['total_amount_dinar'] > 0
              ? isDark
                ? ' from-red-500 '
                : ' from-red-50 to-red-100 '
              : isDark
              ? ' from-green-500 '
              : ' from-green-50 to-green-100 '
          "
        />
        <ReportComponenet1Number
          :labelTxt="formatNumber(total['total_amount_dollar'])"
          :labelTitle="$t('total_debt_dollar')"
          :classColor="
            total['total_amount_dollar'] > 0
              ? isDark
                ? ' from-red-500 '
                : ' from-red-50 to-red-100 '
              : isDark
              ? ' from-green-500 '
              : ' from-green-50 to-green-100 '
          "
        />
      </div>
    </div>
    <!-- Table Container -->
    <div class="px-6 py-4">
      <div
        class="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden"
      >
        <div
          class="flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-700 no-print"
        >
          <div class="flex items-center space-x-4">
            <BaseInput
              :modelValue="$store.state.debt_list.search"
              @update:modelValue="handleSearchInput"
              :placeholder="$t('search')"
              :prefixIcon="'fa-solid fa-search'"
              class="w-40 md:w-full"
            /> <button
              class="mx-2 my_font bg-primaryColor hover:bg-blue-700 text-white font-bold py-1 px-4 rounded no-print"
              @click="printReportFunc"
              id="button_print"
              v-if="$store.getters['checkPrintAccess']"
            >
              {{ $t("print") }}
            </button>
          </div>

          <!-- Column Selection and Controls -->
          <div class="flex items-center space-x-4">
            <CustomMultiSelect
              v-model="selectedHeaders"
              :options="headers"
              track-by="value"
              label="text"
              :placeholder="$t('columns')"
              :header-text="$t('which_columns_to_display')"
              @update:modelValue="printCall"
            />
            <div class="w-0.5"></div>
            <button
              @click="resetToDefaultHeaders"
              class="group inline-flex items-center justify-center w-10 h-10 bg-gradient-to-br  text-blue-600 dark:text-blue-400 rounded-xl border border-blue-200 dark:border-gray-600 hover:from-blue-100 hover:to-indigo-200 dark:hover:from-gray-600 dark:hover:to-gray-700 hover:shadow-lg hover:shadow-blue-200/50 dark:hover:shadow-gray-900/50 hover:scale-105 active:scale-95 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 backdrop-blur-sm"
              :title="$t('reset_to_default')"
            >
              <i
                class="fa fa-refresh text-sm group-hover:rotate-180 transition-transform duration-500"
              ></i>
            </button>
           
          </div>
        </div>
        <EasyDataTable
          v-model:server-options="serverOptions"
          :headers="showHeaders"
          :items="items"
          :server-items-length="serverItemsLength"
          :loading="isLoadingData"
          :alternating="false"
          :buttons-pagination="true"
          :body-text-direction="$store.getters['isRtl'] ? 'right' : 'left'"
          :hide-footer="isHide"
          :rows-items="[25, 50, 100, serverItemsLength]"
          rows-per-page="10"
          :table-class-name="isDark ? 'modern-dark-table' : ''"
        >
          <template #default="{ column, sortDirection }">
            <div
              :class="`flex items-center space-x-2 ${
                $store.getters['isRtl'] ? 'justify-end' : 'justify-start'
              }`"
            >
              <span class="font-semibold text-gray-700 dark:text-gray-300">{{
                column.label
              }}</span>
              <span v-if="column.sortable" class="text-gray-400">
                <i
                  v-if="sortDirection === 'asc'"
                  class="fa-solid fa-arrow-up text-blue-500"
                ></i>
                <i
                  v-else-if="sortDirection === 'desc'"
                  class="fa-solid fa-arrow-down text-blue-500"
                ></i>
                <i v-else class="fa-solid fa-arrows-up-down"></i>
              </span>
            </div>
          </template>
          <template #item-actions="item">
            <button
              class="mx-1 my-1"
              @click="showModal(item)"
              v-if="
                $store.getters['checkUserAccess']({
                  id: '21',
                  action: 'edit',
                })
              "
            >
              <i
                class="fa-solid fa-pen text-center p-1 w-7 h-7 text-sm bg-blue-200 dark:bg-blue-300 rounded-md text-blue-500 mx-auto"
              >
                {{ item.text }}
              </i>
            </button>
            <button
              class="mx-1 my-1"
              @click="deleteItem(item.deb_id)"
              v-if="
                $store.getters['checkUserAccess']({
                  id: '21',
                  action: 'delete',
                })
              "
            >
              <i
                class="fa-solid fa-trash text-center p-1 w-7 h-7 text-sm bg-red-200 dark:bg-red-300 rounded-md text-red-500 mx-auto"
              ></i>
            </button>
            <a
              class="mx-1 my-1"
              :href="'debt-detail/' + item.deb_id"
              v-if="
                $store.getters['checkUserAccess']({
                  id: '21',
                  action: 'detail',
                })
              "
              target="_blank"
            >
              <i
                class="m-1 fa-solid fa-eye text-center p-1 w-7 h-7 text-sm bg-green-200 dark:bg-blue-300 rounded-md text-green-500 mx-auto"
              >
                {{ item.text }}
              </i>
            </a></template
          >
          <template #item-currency_cur_name="item">
            {{ $t(item.currency.cur_name) }}
          </template>
          <template #item-customer_cu_name="item">
            <span
              v-if="item.customer == null || item.customer == ''"
              class="text-lg font-bold"
            >
              __
            </span>
            <span v-else>
              {{ item.customer.cu_name }}
            </span>
          </template>
          <template #item-suplier_su_name="item">
            <span
              v-if="item.suplier == null || item.suplier == ''"
              class="text-lg font-bold"
            >
              __
            </span>
            <span v-else>
              {{ item.suplier.su_name }}
            </span>
          </template>
          <template #item-deb_note="item">
            <span
              v-if="item.deb_note == null || item.deb_note == ''"
              class="text-lg font-bold"
            >
              __
            </span>
            <span v-else>
              {{ item.deb_note }}
            </span>
          </template>
          <template #item-deb_return_date="item">
            <span
              v-if="item.deb_return_date == null || item.deb_return_date == ''"
              class="text-lg font-bold"
            >
              __
            </span>
            <span v-else>
              {{ item.deb_return_date }}
            </span>
          </template>
          <template #item-deb_wasl="item">
            <span
              v-if="item.deb_wasl == null || item.deb_wasl == ''"
              class="text-lg font-bold"
            >
              __
            </span>
            <span v-else>
              {{ item.deb_wasl }}
            </span>
          </template>
          <template #item-deb_amount="item">
            {{ formatNumber(item.deb_amount) }}
          </template>
          <template #item-deb_main_currency_price="item">
            {{ formatNumber(item.deb_main_currency_price) }}
          </template>
          <template #item-deb_type="item">
            <span
              :class="
                item.deb_type == $t('sale_due')
                  ? 'text-yellow-500 font-bold'
                  : ''
              "
              v-show="item.deb_type == $t('sale_due')"
            >
              {{ $t("sale_due") }}
            </span>
            <span
              :class="
                item.deb_type == $t('return_to_suplier_by_due')
                  ? 'text-yellow-500 font-bold'
                  : ''
              "
              v-show="item.deb_type == $t('return_to_suplier_by_due')"
            >
              {{ $t("return_to_suplier_by_due") }}
            </span>
            <span
              :class="
                item.deb_type == $t('purchase_due')
                  ? 'text-yellow-500 font-bold'
                  : ''
              "
              v-show="item.deb_type == $t('purchase_due')"
            >
              {{ $t("purchase_due") }}
            </span>
            <span
              :class="
                item.deb_type == $t('borrow') ? 'text-green-500 font-bold' : ''
              "
              v-show="item.deb_type == $t('borrow')"
            >
              {{ $t("borrow") }}
            </span>
            <span
              :class="
                item.deb_type == $t('lend') ? 'text-red-500 font-bold' : ''
              "
              v-show="item.deb_type == $t('lend')"
            >
              {{ $t("lend") }}
            </span> </template
          ><template #item-pu_id="item">
            <span
              v-if="item.pu_id == null || item.pu_id == ''"
              class="text-lg font-bold"
            >
              __
            </span>
            <span v-else>
              {{ item.pu_id }}
            </span> </template
          ><template #item-in_id="item">
            <span
              v-if="item.in_id == null || item.in_id == ''"
              class="text-lg font-bold"
            >
              __
            </span>
            <span v-else>
              {{ item.in_id }}
            </span>
          </template>

          <template #item-rep_id="item">
            <span
              v-if="item.rep_id == null || item.rep_id == ''"
              class="text-lg font-bold"
            >
              __
            </span>
            <span v-else>
              {{ item.rep_id }}
            </span>
          </template>
          <template #item-box_bo_name="item">
            <span
              v-if="item.box == null || item.box == ''"
              class="text-lg font-bold"
            >
              __
            </span>
            <span v-else>
              {{ item.box.bo_name }}
            </span>
          </template>
          <template #item-deb_image="item">
            <img
              :src="file_url + item.deb_image"
              class="inline-flex items-center justify-center text-white transition-all duration-200 ease-in-out text-size-sm h-16 w-16 rounded-xl"
              v-if="item.deb_image"
              @click="openModal(file_url + item.deb_image)"
            />
            <span v-if="item.deb_image == '' || item.deb_image == null">
              <i class="fa-solid fa-image text-primaryColor"></i>
            </span>
          </template>
          <template #loading>
            <div class="flex flex-col items-center justify-center py-8">
              <div
                class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mb-4"
              ></div>
              <p class="text-gray-500 dark:text-gray-400 text-sm">
                {{ $t("loading") }}...
              </p>
            </div>
          </template>
          <template #item-created_at="item">
            {{ formatDate(item.created_at) }}
          </template>
          <template #empty-message>
            <div class="flex flex-col items-center justify-center py-12">
              <i
                class="fa-solid fa-inbox text-4xl text-gray-400 dark:text-gray-600 mb-4"
              ></i>
              <p
                class="text-lg font-medium text-gray-700 dark:text-gray-300 mb-2"
              >
                {{ $t("no_data_found") }}
              </p>
              <p class="text-sm text-gray-500 dark:text-gray-400">
                {{ $t("try_adjusting_your_search_criteria") }}
              </p>
            </div>
          </template>
          <template
            #pagination="{
              prevPage,
              nextPage,
              isFirstPage,
              isLastPage,
              currentPaginationNumber,
              maxPaginationNumber,
            }"
          >
            <button :disabled="isFirstPage" @click="goToPage(1)">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-double-right'
                    : ' fa-angle-double-left')
                "
              ></i>
            </button>
            <div class="w-5"></div>
            <button :disabled="isFirstPage" @click="prevPage">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-right'
                    : ' fa-angle-left ')
                "
              ></i>
            </button>
            <div class="w-5"></div>
            <button
              v-for="page in getVisiblePages(
                currentPaginationNumber,
                maxPaginationNumber
              )"
              :key="page"
              @click="goToPage(page)"
              :class="getPageButtonClasses(page, currentPaginationNumber)"
            >
              {{ page }}
            </button>

            <div class="w-5"></div>
            <button :disabled="isLastPage" @click="nextPage">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-left'
                    : ' fa-angle-right')
                "
              ></i>
            </button>
            <div class="w-5"></div>
            <button
              :disabled="isLastPage"
              @click="goToPage(maxPaginationNumber)"
            >
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-double-left'
                    : ' fa-angle-double-right')
                "
              ></i>
            </button> </template
        ></EasyDataTable>
        <!--in ltr change (text-right to text-left)
        <EasyDataTable
          :headers="headers"
          :items="filterItems"
          :body-text-direction="$store.getters['isRtl'] ? 'right' : 'left'"
          alternating
          :header-props="{ 'sort-icon': 'fa-solid fa-arrow-up-wide-short' }"
          :loading="isLoadingData"
          :class="isDark ? 'customize-table ' : 'light-mode-table'"
        >
          <template #default="{ column, sortDirection }">
            <div :class="`flex items-center space-x-2 ${$store.getters['isRtl'] ? 'justify-end' : 'justify-start'}`">
              <span class="font-semibold text-gray-700 dark:text-gray-300">{{ column.label }}</span>
              <span v-if="column.sortable" class="text-gray-400">
                <i
                  v-if="sortDirection === 'asc'"
                  class="fa-solid fa-arrow-up text-blue-500"
                ></i>
                <i
                  v-else-if="sortDirection === 'desc'"
                  class="fa-solid fa-arrow-down text-blue-500"
                ></i>
                <i v-else class="fa-solid fa-arrows-up-down"></i>
              </span>
            </div>
          </template>
          <template #item-actions="item">
            <button class="mx-1" @click="showModal(item)">
              <i
                class="fa-solid fa-pen text-center p-1 w-7 h-7 text-sm bg-blue-200 dark:bg-blue-300 rounded-md text-blue-500 mx-auto"
              >
                {{ item.text }}
              </i>
            </button>
            <button class="mx-1" @click="deleteItem(item.deb_id)">
              <i
                class="fa-solid fa-trash text-center p-1 w-7 h-7 text-sm bg-red-200 dark:bg-red-300 rounded-md text-red-500 mx-auto"
              ></i>
            </button>
            <a class="mx-1" :href="'debt-detail/' + item.deb_id">
              <i
                class="m-1 fa-solid fa-eye text-center p-1 w-7 h-7 text-sm bg-green-200 dark:bg-blue-300 rounded-md text-green-500 mx-auto"
              >
                {{ item.text }}
              </i>
            </a></template
          >
          <template #item-currency_cur_name="item">
            {{ $t(item.currency.cur_name) }}
          </template>
          <template #item-customer_cu_name="item">
            <span
              v-if="item.customer == null || item.customer == ''"
              class="text-lg font-bold"
            >
              __
            </span>
            <span v-else>
              {{ item.customer.cu_name }}
            </span>
          </template>
          <template #item-suplier_su_name="item">
            <span
              v-if="item.suplier == null || item.suplier == ''"
              class="text-lg font-bold"
            >
              __
            </span>
            <span v-else>
              {{ item.suplier.su_name }}
            </span>
          </template>
          <template #item-deb_note="item">
            <span
              v-if="item.deb_note == null || item.deb_note == ''"
              class="text-lg font-bold"
            >
              __
            </span>
            <span v-else>
              {{ item.deb_note }}
            </span>
          </template>
          <template #item-deb_return_date="item">
            <span
              v-if="item.deb_return_date == null || item.deb_return_date == ''"
              class="text-lg font-bold"
            >
              __
            </span>
            <span v-else>
              {{ item.deb_return_date }}
            </span>
          </template>
          <template #item-deb_wasl="item">
            <span
              v-if="item.deb_wasl == null || item.deb_wasl == ''"
              class="text-lg font-bold"
            >
              __
            </span>
            <span v-else>
              {{ item.deb_wasl }}
            </span>
          </template>

          <template #item-deb_type="item">
            <span
              :class="
                item.deb_type == $t('sale_due')
                  ? 'text-yellow-500 font-bold'
                  : ''
              "
              v-show="item.deb_type == $t('sale_due')"
            >
              {{ $t("sale_due") }}
            </span>
            <span
              :class="
                item.deb_type == $t('purchase_due')
                  ? 'text-yellow-500 font-bold'
                  : ''
              "
              v-show="item.deb_type == $t('purchase_due')"
            >
              {{ $t("purchase_due") }}
            </span>
            <span
              :class="
                item.deb_type == $t('borrow') ? 'text-green-500 font-bold' : ''
              "
              v-show="item.deb_type == $t('borrow')"
            >
              {{ $t("borrow") }}
            </span>
            <span
              :class="
                item.deb_type == $t('lend') ? 'text-red-500 font-bold' : ''
              "
              v-show="item.deb_type == $t('lend')"
            >
              {{ $t("lend") }}
            </span> </template
          ><template #item-pu_id="item">
            <span
              v-if="item.pu_id == null || item.pu_id == ''"
              class="text-lg font-bold"
            >
              __
            </span>
            <span v-else>
              {{ item.pu_id }}
            </span> </template
          ><template #item-in_id="item">
            <span
              v-if="item.in_id == null || item.in_id == ''"
              class="text-lg font-bold"
            >
              __
            </span>
            <span v-else>
              {{ item.in_id }}
            </span> </template
          ><template #item-box_bo_name="item">
            <span
              v-if="item.box == null || item.box == ''"
              class="text-lg font-bold"
            >
              __
            </span>
            <span v-else>
              {{ item.box.bo_name }}
            </span>
          </template>
          <template #item-deb_image="item">
            <img
              :src="file_url + item.deb_image"
              class="inline-flex items-center justify-center text-white transition-all duration-200 ease-in-out text-size-sm h-16 w-96 rounded-xl"
              v-if="item.deb_image"
              @click="openModal(file_url + item.deb_image)"
            />
            <span v-if="item.deb_image == '' || item.deb_image == null">
              <i class="fa-solid fa-image text-primaryColor"></i>
            </span>
          </template>
          <template #loading>
            <div class="flex flex-col items-center justify-center py-8">
              <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mb-4"></div>
              <p class="text-gray-500 dark:text-gray-400 text-sm">{{ $t('loading') }}...</p>
            </div>
          </template>
          <template #item-created_at="item">
            {{ formatDate(item.created_at) }} </template
          ><template #empty-message>
            <span class="text-textBlack1 dark:text-white">
              {{ $t("no_data_found") }}
            </span>
          </template>
          <template
            #pagination="{ prevPage, nextPage, isFirstPage, isLastPage }"
          >
            <button :disabled="isFirstPage" @click="prevPage">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-chevron-right'
                    : ' fa-chevron-left')
                "
              ></i>
            </button>
            <div class="w-5"></div>
            <button :disabled="isLastPage" @click="nextPage">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-chevron-left'
                    : ' fa-chevron-right')
                "
              ></i>
            </button>
          </template>
        </EasyDataTable>-->
      </div>
    </div>
  </div>
  <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
  <ResultDialog ref="ResultDialog"></ResultDialog>
  <edit-modal ref="editModal">
    <div class="items-center">
      <form @submit="editItem">
        <BaseInput
          v-model="current.deb_amount"
          :label="$t('debt_amount')"
          :placeholder="$t('debt_amount')"
          :rules="rules"
          type="number"
          :isError="
            checkRulesIsError(current.deb_amount, 'edit', this.rules).isError
          "
          :errorMsg="
            checkRulesIsError(current.deb_amount, 'edit', this.rules).errorMsg
          "
        />
        <div class="mb-6">
          <DropdownInput
            v-model="current.cu_id"
            :label="$t('customer')"
            :placeholder="
              $t('choose_customer_if_debt_is_in_or_out_from_customer')
            "
            :items="convertToListIdValueCustomers"
            :rules="rules_dropdown"
            :isError="
              checkRulesIsError(current.cu_id, 'edit', this.rules_dropdown)
                .isError
            "
            :errorMsg="
              checkRulesIsError(current.cu_id, 'edit', this.rules_dropdown)
                .errorMsg
            "
            @change="updateSelectedCU"
          />
        </div>
        <div class="mb-6">
          <DropdownInput
            v-model="current.su_id"
            :label="$t('suplier')"
            :placeholder="
              $t('chhose_suplier_if_debt_is_in_or_out_from_suplier')
            "
            :items="convertToListIdValueSupliers"
            :rules="rules_dropdown"
            :isError="
              checkRulesIsError(current.su_id, 'edit', this.rules_dropdown)
                .isError
            "
            :errorMsg="
              checkRulesIsError(current.su_id, 'edit', this.rules_dropdown)
                .errorMsg
            "
            @change="updateSelectedSU"
          />
        </div>

        <BaseInput
          v-model="current.deb_wasl"
          :label="$t('debt_invoice_number')"
          :placeholder="$t('debt_invoice_number')"
          :rules="no_rule"
          :isError="
            checkRulesIsError(current.deb_wasl, 'edit', this.no_rule).isError
          "
          :errorMsg="
            checkRulesIsError(current.deb_wasl, 'edit', this.no_rule).errorMsg
          "
        />
        <BaseInput
          v-model="current.created_at"
          type="date"
          :label="$t('debt_date')"
          :placeholder="$t('debt_date')"
          :rules="no_rule"
          :isError="
            checkRulesIsError(current.created_at, 'edit', this.no_rule).isError
          "
          :errorMsg="
            checkRulesIsError(current.created_at, 'edit', this.no_rule).errorMsg
          "
        />
        <BaseInput
          v-model="current.deb_return_date"
          type="date"
          :label="$t('debt_return_date')"
          :placeholder="$t('debt_return_date')"
          :rules="no_rule"
          :isError="
            checkRulesIsError(current.deb_return_date, 'edit', this.no_rule)
              .isError
          "
          :errorMsg="
            checkRulesIsError(current.deb_return_date, 'edit', this.no_rule)
              .errorMsg
          "
        />
        <TextAreaInput
          v-model="current.deb_note"
          :label="$t('note')"
          :placeholder="$t('note')"
          :rules="no_rule"
          :isError="
            checkRulesIsError(current.deb_note, 'edit', this.no_rule).isError
          "
          :errorMsg="
            checkRulesIsError(current.deb_note, 'edit', this.no_rule).errorMsg
          "
        />
        <FileInput
          v-model="deb_image"
          :label="$t('debt_photo')"
          :placeholder="$t('choose_debt_photo')"
          accept="image/*"
          :show-preview="true"
          @change="onChange"
        />
        <br />
        <center>
          <ButtonInput
            type="button"
            @click="editItem"
            :label="$t('edit')"
            :isLoading="isBtnEditLoading"
          />
        </center>
      </form>
    </div> </edit-modal
  ><image-modal ref="imageModal" />
</template>
<script>
import moment from "moment";
import { formatNumber } from "../../utils/functions";

//import hearder-app
import HeaderApp from "../../components/Navbar/header-app.vue";
import BaseInput from "../../components/Inputs/BaseInput.vue";
import ButtonInput from "../../components/Inputs/ButtonInput.vue";
import CustomMultiSelect from "../../components/Inputs/CustomMultiSelect.vue";
import { formatDate } from "../../utils/functions";
import ConfirmDialogue from "../../components/Modals/ConfirmDialogue.vue";
import ResultDialog from "../../components/Modals/ResultDialog.vue";
import EditModal from "../../components/Modals/EditModal.vue";
import TextAreaInput from "../../components/Inputs/TextAreaInput.vue";
import { FILE_URL } from "../../constants/config";
import ImageModal from "../../components/Modals/ImageModal2.vue";
import InvoiceHeader from "../../components/Navbar/InvoiceHeader.vue";
import ReportComponenet1Number from "../../components/Report/ReportComponenet1Number.vue";
import "../../assets/css/modern-table.css";
import DropdownInput from "../../components/Inputs/DropdownInput.vue";
import FileInput from "../../components/Inputs/FileInput.vue";

export default {
  name: "ADD_SALE_TYPE",
  components: {
    HeaderApp,
    BaseInput,
    ButtonInput,
    ConfirmDialogue,
    ResultDialog,
    EditModal,
    ReportComponenet1Number,
    TextAreaInput,
    ImageModal,
    InvoiceHeader,
    DropdownInput,
    CustomMultiSelect,
    FileInput,
  },
  data() {
    return {
      firstName: "",
      rules: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_fill_this_field");
        },
      ],
      rules_dropdown: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_choose_an_option");
        },
      ],
      exc_name: "",
      inputType: "text",
      isSubmited: false,
      isSubmitedEdit: false,
      no_rule: [],
      current: {},
      file_url: FILE_URL,
      deb_image: "",
      serverItemsLength: 0,
      serverOptions: {
        page: 1,
        rowsPerPage: 12,
      },
      loading: false,
      items: [],
      isHide: false,
      selectedHeaders: [],
      columnsControl: false,
    };
  },
  created() {
    this.$store.dispatch("suplier/getSupliers");
    this.$store.dispatch("customer/getCustomers");
    this.$store.dispatch("navbar/getItems");

    this.$store.dispatch("debt_report/getItems", {
      startDate: "2000-01-01",
      endDate: moment().endOf("year").format("YYYY-MM-DD"),
    });
    this.selectedHeaders = [...this.headers];
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    getResultDialog(newValue, oldValue) {
      if (newValue) {
        this.$refs.ResultDialog.show({
          message: this.$store.state.debt_list.resultMsg,
          okButton: this.$t("done"),
          isSuccess: this.$store.state.debt_list.isSuccess,
        });

        // Reset the deleteSuccess state after showing the dialog
        this.$store.commit("debt_list/SET_DELETE_SUCCESS", false);
      }
    },
    serverOptions: {
      handler() {
        this.loadFromServer();
      },
      deep: true,
    },
  },
  mounted() {
    // First load when the component is mounted
    if (
      this.$store.getters["checkUserAccess"]({
        id: "21",
        action: "view",
      })
    ) {
      this.loadFromServer();
    }
    this.loadSelectedHeaders();
  },
  computed: {
    total() {
      return this.$store.state.debt_report.total;
    },
    getResultDialog() {
      return this.$store.state.debt_list.isShowResultDialog;
    },

    filterItems() {
      return this.$store.getters["debt_list/filterItems"];
    },
    isDark() {
      return this.$store.state.theme == "dark";
    },
    isLoadingData() {
      return this.$store.state.debt_list.isLoadingData;
    },
    isBtnLoading() {
      return this.$store.state.debt_list.isBtnLoading;
    },
    isBtnEditLoading() {
      return this.$store.state.debt_list.isBtnEditLoading;
    },
    headers() {
      var listHeader = [
        { text: "#", value: "deb_id", sortable: true },
        {
          text: this.$t("customer"),
          value: "customer_cu_name",
          sortable: true,
        },
        { text: this.$t("suplier"), value: "suplier_su_name", sortable: true },
        { text: this.$t("debt_amount"), value: "deb_amount", sortable: true },
        {
          text: this.$t("currency_type"),
          value: "currency_cur_name",
          sortable: true,
        },
        { text: this.$t("created_at"), value: "created_at", sortable: true },
        {
          text: this.$t("debt_type"),
          value: "deb_type",
          sortable: true,
        },
        { text: this.$t("debt_id"), value: "deb_wasl", sortable: true },
        { text: this.$t("photo"), value: "deb_image", sortable: false },

        {
          text: this.$t("dolar_price"),
          value: "deb_main_currency_price",
          sortable: true,
        },

        { text: this.$t("debt_box"), value: "box_bo_name", sortable: true },

        { text: this.$t("purchase_id"), value: "pu_id", sortable: true },
        { text: this.$t("invoice_sale_id"), value: "in_id", sortable: true },
        {
          text: this.$t("return_purchase_id"),
          value: "rep_id",
          sortable: true,
        },
        { text: this.$t("note"), value: "deb_note", sortable: true },
        {
          text: this.$t("debt_return_date"),
          value: "deb_return_date",
          sortable: true,
        },

        { text: this.$t("admin"), value: "users.name", sortable: true },
        { text: this.$t("actions"), value: "actions", sortable: false },
      ];
      //remove actions if isHide is true
      if (this.isHide) {
        listHeader.pop();
      }
      return listHeader;
    },
    showHeaders() {
      var temp = [];
      //cretae a for check all selectedHeaders add to temp
      for (let i = 0; i < this.selectedHeaders.length; i++) {
        for (let j = 0; j < this.headers.length; j++) {
          if (this.selectedHeaders[i].text == this.headers[j].text) {
            temp.push(this.headers[j]);
          }
        }
      }

      if (temp.length == 0) {
        temp = this.headers;
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.selectedHeaders = temp;
      }

      return temp;
    },
    convertToListIdValueCustomers() {
      var customers = this.$store.state.customer.customers;
      var list = [];
      for (const item of customers) {
        list.push({
          id: item.cu_id.toString(),
          value: item.cu_name,
        });
      }

      return list;
    },
    convertToListIdValueSupliers() {
      var supliers = this.$store.state.suplier.supliers;
      var list = [];
      for (const item of supliers) {
        list.push({
          id: item.su_id.toString(),
          value: item.su_name,
        });
      }

      return list;
    },
  },

  methods: {
    handleSearchInput(value) {
      this.$store.commit("debt_list/SET_SEARCH", value);
      this.loadFromServer();
      this.serverOptions.page = 1;
    },
    loadSelectedHeaders() {
      // Load selected headers from localStorage
      const savedHeaders = localStorage.getItem("debtSelectedHeaders");
      if (savedHeaders) {
        try {
          const parsedHeaders = JSON.parse(savedHeaders);
          // Filter to only include headers that exist in current headers list
          this.selectedHeaders = this.headers.filter((header) =>
            parsedHeaders.some((saved) => saved.value === header.value)
          );
        } catch (error) {
          console.error("Error loading saved headers:", error);
          this.selectedHeaders = [...this.headers];
        }
      } else {
        // If no saved headers, select all by default
        this.selectedHeaders = [...this.headers];
      }
    },
    saveSelectedHeaders() {
      // Save selected headers to localStorage
      try {
        localStorage.setItem(
          "debtSelectedHeaders",
          JSON.stringify(this.selectedHeaders)
        );
      } catch (error) {
        console.error("Error saving headers:", error);
      }
    },
    printCall(selectedHeaders) {
      // Handle column selection changes
      if (selectedHeaders && Array.isArray(selectedHeaders)) {
        this.selectedHeaders = selectedHeaders;
        this.saveSelectedHeaders();
      }
    },
    resetToDefaultHeaders() {
      // Reset to select all headers
      this.selectedHeaders = [...this.headers];
      this.saveSelectedHeaders();
    },
    formatNumber(number) {
      return formatNumber(number);
    },
    printReportFunc() {
      this.isHide = true;
      //wait 1 second
      setTimeout(() => {
        var printContents = document.getElementById("printDev").innerHTML;

        // Replace the body's innerHTML with the print contents
        document.body.innerHTML = printContents;
        var isRtl = this.$store.getters["isRtl"];
        // Set direction based on the parameter
        if (isRtl) {
          document.body.style.direction = "rtl";
        } else {
          document.body.style.direction = "ltr";
        }

        // Print the content
        window.print(); // Adjust the timeout as needed
        //reload page
      }, 100);
      //print element id invoice_print
    },
    getVisiblePages(currentPage, totalPages) {
      const numVisibleButtons = 3; // Adjust this number based on your design preference
      const pages = [];

      // Display pages 1 to numVisibleButtons (e.g., 1, 2, 3)
      if (currentPage <= Math.floor(numVisibleButtons / 2) + 1) {
        for (let i = 1; i <= Math.min(totalPages, numVisibleButtons); i++) {
          pages.push(i);
        }
      }
      // Display pages around the current page (e.g., 1, ..., 10, ..., 20)
      else {
        const startPage = Math.max(
          1,
          currentPage - Math.floor(numVisibleButtons / 2)
        );
        const endPage = Math.min(totalPages, startPage + numVisibleButtons - 1);

        for (let i = startPage; i <= endPage; i++) {
          pages.push(i);
        }
      }

      return pages;
    },

    // Function to get Tailwind CSS classes for each page button
    getPageButtonClasses(page, currentPage) {
      return {
        "bg-blue-500 text-white": page === currentPage,
        "bg-gray-300 text-gray-700 hover:bg-gray-400": page !== currentPage,
        "p-2 rounded-md mx-1": true, // Adjust padding and rounding based on your design
      };
    },

    goToPage(page) {
      // Implement your logic to update the current page
      //update page
      this.serverOptions.page = page;
      this.loadFromServer();
    },
    async loadFromServer() {
      this.loading = true;

      var tempObj = { ...this.serverOptions };
      //add new field to object search
      tempObj.search = this.$store.state.debt_list.search;

      const res = await this.$store.dispatch("debt_list/getItems", tempObj);

      this.items = res.data.data;
      this.items.forEach((element) => {
        if (element.deb_type == 0) {
          element.deb_type = this.$t("borrow");
        } else if (element.deb_type == 1) {
          element.deb_type = this.$t("lend");
        } else if (element.deb_type == 2) {
          element.deb_type = this.$t("purchase_due");
        } else if (element.deb_type == 3) {
          element.deb_type = this.$t("sale_due");
        } else if (element.deb_type == 4) {
          element.deb_type = this.$t("return_to_suplier_by_due");
        }
      });
      this.serverItemsLength = res.data.total;
      this.loading = false;
    },
    openModal(image) {
      this.$refs.imageModal.show(image);
    },
    onChange(e) {
      this.deb_image = e.target.files[0];
      e.target.value = "";
    },

    formatDate(date) {
      return formatDate(date);
    },

    showImage(url) {
      window.open(url, "_blank");
    },

    checkRulesIsError(value, type, rules) {
      var isError = false;
      var errorMsg = "";

      if (type == "edit") {
        if (this.isSubmitedEdit == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }
      for (const rule of rules) {
        if (rule(value) !== true) {
          isError = true;
          errorMsg = rule(value);
          // Stop the loop
          break;
        } else {
          isError = false;
          errorMsg = "";
        }
      }

      return {
        isError: isError,
        errorMsg: errorMsg,
      };
    },
    async deleteItem(id) {
      const ok = await this.$refs.confirmDialogue.show({
        message: this.$t("are_you_sure_remove_this_item") + id,
        okButton: this.$t("delete"),
      });
      if (ok) {
        this.$store.commit("debt_list/REMOVE_ITEM", id);
        await this.$store.dispatch("debt_list/deleteItem", id);
        this.loadFromServer();
      }
    },
    //edit
    async showModal(item) {
      this.current = item;
      //if not null
      this.current.created_at = this.current.created_at
        .toString()
        .split("T")[0];
      if (this.current.su_id != null) {
        //check if su_id number
        if (typeof this.current.su_id == "number") {
          this.current.su_id = item.su_id.toString();
        } else {
          this.current.su_id = item.su_id.toString();
        }
      } else {
        this.current.su_id = "";
      }
      if (this.current.cu_id != null) {
        //check if cu_id number
        if (typeof this.current.cu_id == "number") {
          this.current.cu_id = item.cu_id.toString();
        } else {
          this.current.cu_id = item.cu_id.toString();
        }
      } else {
        this.current.cu_id = "";
      }
      await this.$refs.editModal.show();
    },
    updateSelectedCU(value) {
      console.log(value);
      this.current.cu_id = value.id;
      // Clear supplier when customer is selected
      if (value && value !== "") {
        this.current.su_id = "";
      }
    },
    updateSelectedSU(value) {
      this.current.su_id = value.id;
      // Clear customer when supplier is selected
      if (value && value !== "") {
        this.current.cu_id = "";
      }
    },
    async editItem(e) {
      e.preventDefault();
      this.isSubmitedEdit = true;

      if (
        this.checkRulesIsError(this.current.deb_amount, "edit", this.rules)
          .isError
      ) {
        return;
      }
      // Check if both customer and supplier are selected (not allowed)
      if (
        this.current.cu_id && this.current.cu_id !== "" &&
        this.current.su_id && this.current.su_id !== ""
      ) {
        this.$refs.editModal.hide();
        this.$refs.ResultDialog.show({
          message: this.$t("you_must_choose_only_customer_or_suplier"),
          okButton: this.$t("ok"),
          isSuccess: false,
        });
        return;
      }
      // Check if neither customer nor supplier is selected (not allowed)
      if (
        (!this.current.cu_id || this.current.cu_id === "") &&
        (!this.current.su_id || this.current.su_id === "")
      ) {
        this.$refs.editModal.hide();
        this.$refs.ResultDialog.show({
          message: this.$t("you_must_choose_at_least_one_customer_or_suplier"),
          okButton: this.$t("ok"),
          isSuccess: false,
        });
        return;
      }

      this.$store.state.debt_list.isBtnEditLoading = true;
      var res = await this.$store.dispatch("debt_list/editItem", {
        deb_id: this.current.deb_id,
        cu_id: this.current.cu_id,
        deb_note: this.current.deb_note,
        deb_wasl: this.current.deb_wasl,
        deb_amount: this.current.deb_amount,
        created_at: this.current.created_at,
        deb_return_date: this.current.deb_return_date,
        su_id: this.current.su_id,
        deb_image: this.deb_image,
      });

      this.isSubmitedEdit = false;
      this.$store.state.debt_list.isBtnEditLoading = false;
      this.deb_image = "";
      if (res.status == 200) {
        this.$refs.editModal.hide();
        this.loadFromServer();
      }
    },
    //check isEmty
    checkIsEmpty(value) {
      if (value == "" || value == null) return true;
      return false;
    },
  },
};
</script>
